import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Outlet,
} from "react-router-dom";

/* PUBLIC LAYOUT */
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

/* ADMIN LAYOUT */
import NavBarAdmin from "./components/AdminNavBar/NavBarAdmin";

/* PUBLIC PAGES */
import Home from "./pages/Home";
import JuniorPenetrationTester from "./pages/courses/JuniorPenetrationTester";
import SeniorPenetrationTester from "./pages/courses/SeniorPenetrationTester";
import Blog from "./pages/Blog";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";

/* BLOG PAGES */
import PenetrationTesting from "./pages/blogs/PenetrationTesting";
import ReconnaissanceInPenetrationTesting from "./pages/blogs/ReconnaissanceInPenetrationTesting";
import SessionManagement from "./pages/blogs/SessionManagement";
import SqliWithSqlMap from "./pages/blogs/SqliWithSqlMap";
import SqlInjection from "./pages/blogs/SqlInjection";
import ThreatModeling from "./pages/blogs/ThreatModeling";
import BrokenAccessControlAuthentication from "./pages/blogs/BrokenAccessControlAuthentication";

/* DEMO PAGES */
import JuniorPenetrationTesterDemo from "./pages/demo/JuniorPenetrationTesterDemo";
import SeniorPenetrationTesterDemo from "./pages/demo/SeniorPenetrationTesterDemo";

/* THANK YOU PAGES */
import ThankYouJunior from "./pages/thankyou/ThankYouJunior";
import ThankYouSenior from "./pages/thankyou/ThankYouSenior";

/* ADMIN PAGES */
import AdminWorkForPI from "./pages/admin/AdminWorkForPI";
import LoginPage from "./pages/admin/login/LoginPage";
import OtpVerification from "./pages/admin/login/OtpVerification"

function PageTitle() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    if (path === "/") {
      document.title = "Home | Practical Infosec";
      return;
    }

    const pageName = path
      .replace(/^\/+/, "")
      .split("/")
      .filter(Boolean)
      .map((segment) =>
        segment
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      )
      .join(" | ");

    document.title = `${pageName} | Practical Infosec`;
  }, [location.pathname]);

  return null;
}

/* PUBLIC WEBSITE LAYOUT */
function PublicLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}

/* ADMIN WEBSITE LAYOUT */
function AdminLayout() {
  return (
    <>
      <NavBarAdmin />
      <Outlet />
    </>
  );
}

function AppContent() {
  return (
    <>
      <PageTitle />

      <Routes>
        {/* ================= PUBLIC ROUTES ================= */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />

          <Route
            path="/junior-penetration-tester"
            element={<JuniorPenetrationTester />}
          />

          <Route
            path="/senior-penetration-tester"
            element={<SeniorPenetrationTester />}
          />

          <Route path="/blog" element={<Blog />} />

          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          {/* BLOG ROUTES */}
          <Route path="/penetration-testing" element={<PenetrationTesting />} />

          <Route
            path="/reconnaissance-in-penetration-testing"
            element={<ReconnaissanceInPenetrationTesting />}
          />

          <Route path="/session-management" element={<SessionManagement />} />
          <Route path="/sqli-with-sqlmap" element={<SqliWithSqlMap />} />
          <Route path="/sql-injection" element={<SqlInjection />} />
          <Route path="/threat-modeling" element={<ThreatModeling />} />

          <Route
            path="/broken-access-control-authentication"
            element={<BrokenAccessControlAuthentication />}
          />

          {/* DEMO ROUTES */}
          <Route
            path="/junior-penetration-tester-demo"
            element={<JuniorPenetrationTesterDemo />}
          />

          <Route
            path="/senior-penetration-tester-demo"
            element={<SeniorPenetrationTesterDemo />}
          />

          {/* THANK YOU ROUTES */}
          <Route path="/thank-you-junior" element={<ThankYouJunior />} />
          <Route path="/thank-you-senior" element={<ThankYouSenior />} />
        </Route>

        {/* ================= ADMIN ROUTES ================= */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="admin-work-pi" element={<AdminWorkForPI />} />
          <Route path="sign_in" element={<LoginPage />} />
          <Route path="verify-otp" element={<OtpVerification />} />
        </Route>
      </Routes>
    </>
  ); 
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}